import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Читает указанные ключи из URL search params и возвращает начальные значения
 * для searchText (текстовые фильтры) и filters (dropdown-фильтры).
 *
 * Пример использования:
 *   const { initialSearchText, initialFilters, hasUrlFilters } = useSearchParamsInit({
 *     searchTextKeys: ['clientId'],
 *     filterKeys: ['status'],
 *   })
 */
export const useSearchParamsInit = (config: {
  searchTextKeys?: string[]
  filterKeys?: string[]
}) => {
  const [searchParams] = useSearchParams()

  return useMemo(() => {
    const initialSearchText: Record<string, string> = {}
    const initialFilters: Record<string, string[]> = {}
    let hasUrlFilters = false

    config.searchTextKeys?.forEach((key) => {
      const value = searchParams.get(key)
      if (value) {
        initialSearchText[key] = value
        hasUrlFilters = true
      }
    })

    config.filterKeys?.forEach((key) => {
      const value = searchParams.get(key)
      if (value) {
        initialFilters[key] = [value]
        hasUrlFilters = true
      }
    })

    return { initialSearchText, initialFilters, hasUrlFilters }
  }, [searchParams])
}
